import { alpha, Card, SxProps } from "@mui/material";
import { m } from "framer-motion";
import { useContext } from "react";
import CustomContext from "src/pages/App/AppSettings/Customization/context";
import palette from "src/theme/palette";

import Context from "../context";

// ----------------------------------------------------------------------

type Props = {
	sx?: SxProps;
	isSelected?: boolean;
	children: React.ReactNode;
};

export const CardWrapper = ({ sx, isSelected, children }: Props) => {
	const { values } = useContext(Context);
	const { state } = useContext(CustomContext);

	const shadowColor = state.type === "DARK" ? "#000000" : palette.light.grey[500];

	const variants = {
		active: {
			y: 0,
			transition: { duration: 0.3 }
		},
		inactive: {
			opacity: 0.3,
			y: 20,
			transition: { duration: 0.3 }
		},
		hover: { y: 5, opacity: 0.6, transition: { duration: 0.3 } },
		hoveSelected: { y: 0, transition: { duration: 0.3 } }
	};

	return (
		<Card
			sx={{
				...sx,
				p: 4,
				backgroundColor: values.contentBackgroundColor,
				boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(
					shadowColor,
					0.12
				)}`
			}}
			component={m.div}
			variants={variants}
			animate={isSelected ? "active" : "inactive"}
			whileHover={isSelected ? "hoveSelected" : "hover"}
		>
			{children}
		</Card>
	);
};

export default CardWrapper;
